export let LoggerTransportType = /*#__PURE__*/function (LoggerTransportType) {
  LoggerTransportType["CONSOLE"] = "console";
  LoggerTransportType["APPLICATION_INSIGHTS"] = "applicationInsights";
  return LoggerTransportType;
}({});
//# sourceMappingURL=LoggerTransportType.js.map